<template>
  <div class="course-detail">
    <el-breadcrumb class="bread-crumb wrapper">
      <!-- <el-breadcrumb-item :to="{ path: '/home/education' }">智慧教育</el-breadcrumb-item> -->
      <el-breadcrumb-item :to="{ path: '/home/courseList',}">课程列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{courseInfo && courseInfo.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="detail-container course-detail-wrapper">
      <div class="course-info flex-layout">
        <!-- 左侧课程封面图 -->
        <img class="cover" :src="downloadURL+courseInfo.cover"
          :onerror="$store.state.course.defaultCourseCover[`${$route.query.index % 5}`]" />
        <!-- 右侧课程信息 -->
        <div class="base-info-right">
          <div class="info-part flex-between">
            <div>
              <p class="title">{{courseInfo && courseInfo.name}}</p>
              <p class="project-name">{{courseInfo.project && courseInfo.project.name}}项目</p>
              <p class="teacher">授课老师：{{courseInfo.teacherInfo && courseInfo.teacherInfo.name}}</p>
              <p class="time">课程时间：{{courseInfo && courseInfo.timeScope}}</p>
            </div>
            <el-button type="primary" class="into-course btn" :class="{'btn-no':courseInfo.canView == 0}"
              @click="golive(courseInfo)">
              开始学习
            </el-button>
          </div>
          <!-- 统计数据 -->
          <div class="count-data flex-align-around">
            <div v-for="(item,index) in countData" :key="index"
              v-show="(item.title !== 'totalSign' && courseInfo.lessonsPattern == 1) || courseInfo.lessonsPattern != 1">
              <!-- 非学习时长的其他项 -->
              <span class="count" v-if="item.title !== 'totalLearn'">{{item.score}}<i>{{item.unit}}</i></span>
              <!-- 学习时长 -->
              <!-- <span class="count" v-else>
                <span
                  v-if="courseInfo.totalLearn >= 60">{{courseInfo.totalLearn | transformTimeFormat('hour') }}<i>小时</i></span>
                <span>{{courseInfo.totalLearn | transformTimeFormat('min') }}<i>分钟</i></span>
              </span> -->

              <span class="count" v-else>
                <span
                  v-if="courseInfo.totalLearn >= 3600">{{courseInfo.totalLearn | transformTimeFormat('hour') }}<i>小时</i></span>
                <span
                  v-if="courseInfo.totalLearn >= 60">{{courseInfo.totalLearn | transformTimeFormat('min') }}<i>分钟</i></span>
                <span>{{courseInfo.totalLearn | transformTimeFormat('second') }}<i>秒</i></span>
              </span>
              <br />{{item.title | handleCountData(courseInfo.lessonsPattern , courseInfo.classType)}}
            </div>
          </div>
        </div>

      </div>

      <!-- 下部分 -->
      <div class="detail-info flex-between">
        <div class="catalog">
          <el-tabs v-model="currentTab" :stretch="true" @click="currentTab = tab.title">
            <el-tab-pane :label="tab.name" :name="tab.title" v-for="tab in tabs" :key="tab.title">
              <component class="tab" v-bind:is="currentTabComponent" :courseDesc="courseInfo"
                v-if="`tab-${tab.title.toLowerCase()}` == currentTabComponent"></component>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="aside">
          <div class="teacher-info">
            <h4>授课老师</h4>
            <div class="name-part">
              <img :src="courseInfo.teacherInfo && downloadURL+ courseInfo.teacherInfo.avatar" alt=""
                :onerror="$store.state.user.defaultAvatar" class="avatar" />
              <span class="name">{{courseInfo.teacherInfo && courseInfo.teacherInfo.name}}</span>
              <span class="title">{{courseInfo.teacherInfo && courseInfo.teacherInfo.title}}</span>
            </div>
            <p class="discribe">
              {{courseInfo.teacherInfo && courseInfo.teacherInfo.introduce || '暂无简介'}}
            </p>
          </div>
          <tab-comment></tab-comment>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Introduce from "./components/course/course_introduce.vue"
  import Catalog from "./components/course/course_catalog"
  import comment from "./components/course/course_comment"

  export default {
    components: {
      'tab-introduce': Introduce,
      'tab-catalog': Catalog,
      'tab-comment': comment
    },
    computed: {
      currentTabComponent: function () {
        return "tab-" + this.currentTab.toLowerCase();
      }
    },
    data() {
      return {
        from: 'course',
        courseInfo: { //课程信息
          // mark: 2,
        },
        currentTab: 'Catalog',
        tabs: [{
            title: "Catalog",
            name: '课程大纲'
          },
          {
            title: "Introduce",
            name: '简介'
          },

          // {
          //   title: "Task",
          //   name: '作业'
          // },
          // {
          //   title: "Discuss",
          //   name: '讨论'
          // }
        ],
        // countData: {
        //   // totalReserve:0,
        //   totalWatch: 0,
        //   totalWork: 0,
        //   totalLearn: 0,
        //   totalSign: 0,
        //   totalScore: 0
        // },
        countData: [{
            title: 'totalWatch',
            name: '出勤人次',
            score: 0,
            unit: '人'
          },
          {
            title: 'totalWork',
            name: '提交作业数',
            score: 0,
            unit: '次'
          },
          {
            title: 'totalLearn',
            name: '学习总时长',
            score: 0,
            unit: '时'
          },
          {
            title: 'totalSign',
            name: '签到总次数',
            score: 0,
            unit: '次'
          },
          {
            title: 'totalScore',
            name: '学员积分',
            score: 0,
            unit: '分'
          }
        ],
        nextLessonInfo: {}, //下一任务信息
        // markMap: this.$store.state.course.markMap,
        downloadVisible: false,
        // liveLessonId: '', //直播课节ID

        // showGuide_stepone: true,
        // showGuide_steptwo: false,
        // identity: null
      };
    },
    filters: {
      // 分钟转小时分钟
      transformTimeFormat(value, type) {
        // console.log(value)
        if (!value) return 0;
        if (type == 'hour') return parseInt(value / 3600);

        if (type == 'min' && value >= 3600) {
          return parseInt((value % 3600) / 60);
        }
        if (type == 'min' && value < 3600) {
          return parseInt(value / 60);
        }
        if (type == 'second') return parseInt(value % 60);
      },
      // 统计数据文字对照
      handleCountData(value, pattern, classType) {
        // console.log(value)
        let contrastChart = {
          totalReserve: '预约总人数',
          totalWatch: pattern == 1 ? '观看总人数' : '出勤人数',
          totalWork: '提交作业数',
          totalLearn: '学习总时长',
          totalSign: classType == 4 ? '上台总人数' : '签到总次数',
          totalScore: '学员积分',
        }
        return contrastChart[value]
      },
    },
    watch: {},

    methods: {
      handleDownLoad(data) {
        // console.log(data);
        this.downloadVisible = data.visible;
      },
      // toggle() {
      //   this.showGuide_stepone = false
      //   this.showGuide_steptwo = true
      // },
      // close() {
      //   this.showGuide_steptwo = false
      //   this.$store.commit('changestatus', false)
      // },

      golive(item) {
        console.log(item)
        if (item.canView == 0) {
          this.$message({
            message: '您无权限查看该内容，请选择其他课程查看',
            type: 'error'
          });
          return;
        }

        if (item.canView == 2) {
          this.$store.commit('isDisplayLogin', true);
          return;
        }

        if (item.classinUrl) {
          window.open(item.classinUrl);
          return;
        }

        // 公开课
        if (item.lessonsPattern == -1) {
          if (item.urlType == 1 && item.mark === 11) {
            this.$router.push({
              path: '/asynclive',
              query: {
                id: item.liveLessonId,
              }
            });
          } else if (item.urlType == 0) {
            window.open(item.link);
          } else {
            return
          }
        }
        // 同步课异步课
        if (item.mark === 2) { //进入直播蓝色
          this.downloadVisible = true;
          // this.$router.push({
          //   path: "/live",
          //   query: {
          //     id: item.liveLessonId
          //   }
          // })
        } else if (item.mark === 11) { // 进入学习蓝色
          this.currentTab = 'Catalog'
          sessionStorage.setItem('coursePage', 'Catalog')
          window.scrollTo(0, 550)
          // this.$router.push({
          //   path: '/asynclive',
          //   query: {
          //     id: item.liveLessonId
          //   }
          // });
        } else {
          this.currentTab = 'Catalog'
          sessionStorage.setItem('coursePage', 'Catalog')
          window.scrollTo(0, 550)
          return
        }
      },
      //获取下一任务
      // async getNextLesson() {
      //   let courseID = this.$route.params.id
      //   let resData = await this.$Api.Course.getNextLesson(courseID)
      //   // console.log(resData);
      //   this.nextLessonInfo = resData.data
      // },
      //获取课程信息
      async getCourseInfo() {
        // let courseID = this.$route.params.id
        let params = {
          courseId: this.$route.params.id
        }
        let resData = await Api.Home.getCourseDetail(params)
        console.log(resData.data);
        this.courseInfo = resData.data
        // 统计数据
        this.countData.map((item) => {
          item.score = this.courseInfo[item.title]
        })
      },
      // 页面初始化
      init() {
        this.getCourseInfo();
      },
    },
    mounted() {
      this.init();
    }
  };
</script>

<style lang="less" scoped>
  .course-detail {
    background-color: #f9f9f9 !important;
    padding-bottom: 105px;

    // 面包屑导航
    // .breadcrumb {
    //   margin: 41px auto 27px;
    // }
    .course-detail-wrapper {
      width: 990px;
      margin: 0 auto 79px;
      // flex: 1;
    }

    // 课程信息 start
    .course-info {
      background: #fff;
      border: 1px solid #F2F2F2;
      border-radius: 8px;
      padding: 25px 28px;
    }

    // 课程基础信息

    // 课程封面
    .cover {
      width: 389px;
      height: 230px;
      margin-right: 15px;
    }

    .base-info-right {
      width: 100%;
    }

    // 课程标题部分
    .info-part {
      // margin-left: 18px;
      padding-top: 12px;

      .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      .project-name,
      .teacher,
      .time {
        color: #999;
        font-size: 12px;
        margin-bottom: 6px;
      }

      .time {
        margin-bottom: 0px !important;
      }
    }

    // 进入直播大按钮
    .into-course {
      align-self: flex-end;
      padding: 0 22px;
      line-height: 30px;
      font-size: 14px;
      font-weight: 500;
      background-color: #508EF9;
      border-radius: 25px;

      &.btn-no {
        background-color: #c0c0c0;
        border-color: #c0c0c0;
      }


    }

    // 数据统计
    .count-data {
      margin-top: 40px;
      padding: 14px 0;
      font-size: 12px;
      text-align: center;
      color: #999;
      background-color: #FAFAFA;


      .count {
        color: #F66E39;
        font-size: 21px;
        font-weight: bold;

        i {
          font-size: 12px;
          font-weight: 300;
        }
      }

      &>div:nth-child(2) .count {
        color: #50AFF9;
      }

      &>div:nth-child(3) .count {
        color: #FFA955;
      }

      &>div:nth-child(4) .count {
        color: #3DDB9A;
      }

      &>div:nth-child(5) .count {
        color: #5370A2;
      }
    }

    // 课程信息 end
    .detail-info {
      margin-top: 32px;
    }

    .teacher-info {
      box-sizing: border-box;
      width: 279px;
      min-height: 210px;
      max-height: 290px;
      border: 1px solid #f2f2f2;
      border-radius: 8px;
      background-color: #fff;
      padding: 0 20px;

      padding-bottom: 15px;
      overflow-y: auto;

      /*修改滚动条样式*/
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 2px;
      }

      &::-webkit-scrollbar-button {
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 4px;
      }


      h4 {
        line-height: 40px;
        font-size: 13px;
        color: #555;
        border-bottom: 1px solid #f9f9f9;

        span {
          font-size: 12px;
          align-self: flex-end;
        }
      }
    }

    .name-part {
      margin: 10px 0 18px;

      .avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;

        vertical-align: middle;
      }

      .name,
      .title {
        margin-left: 12px;
        font-size: 12px;
        font-weight: 600;
      }

    }

    .discribe {
      color: #666;
      font-size: 12px;
      line-height: 24px;
      // padding-bottom: 40px;
    }





    // 四模块 start

    .catalog {
      box-sizing: border-box;
      padding: 0 35px 0 23px;
      width: 681px;
      max-height: 670px;
      overflow-y: auto;
      border: 1px solid #f2f2f2;
      border-radius: 8px;
      background-color: #fff;

      /*修改滚动条样式*/
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 2px;
      }

      &::-webkit-scrollbar-button {
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 4px;
      }

    }

    /deep/ .el-tabs__header {
      background-color: #fff;
      margin: 0;

      .el-tabs__item {
        padding: 0 20px !important;
        font-size: 14px;
        // font-weight: bold;
        color: #555555;
        height: 40px;
        line-height: 40px;

      }

      .el-tabs__nav-wrap.is-top {
        padding: 0 13px;
      }

      .el-tabs__item:hover {
        color: #508EF9;
      }

      .el-tabs__item.is-active {
        color: #508EF9;

      }
    }

    /deep/ .el-tabs__active-bar {
      height: 1px;
      background-color: #508EF9;
      padding: 0 20px;
      margin-left: -20px;
    }

    /deep/ .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #f2f2f2;
    }

    /deep/ .el-tabs__nav.is-stretch>* {
      flex: 0 0 15%;
    }

    // 四模块 end
    @media screen and (min-width:1250px) {

      // width: 1200px;
      .course-detail-wrapper {
        width: 1200px;
      }

      .course-info {
        padding: 27px 34px;
      }

      .cover {
        width: 455px;
        height: 256px;
        margin-right: 31px;
      }

      .info-part {
        .title {
          font-size: 19px;
          margin-bottom: 13px;
        }

        .project-name,
        .teacher,
        .time {
          font-size: 14px;
          margin-bottom: 8px;
        }
      }

      .into-course {
        padding: 0 26px;
        font-size: 15px;
        line-height: 36px;
      }

      .count-data {
        font-size: 13px;

        .count {
          font-size: 25px;
        }
      }

      .teacher-info {
        width: 340px;
        padding: 0 25px;
        padding-bottom: 20px;

        h4 {
          font-size: 16px;
        }
      }

      .name-part {
        margin: 12px 0 25px;

        .avatar {
          width: 41px;
          height: 41px;
        }

        .name,
        .title {
          margin-left: 15px;
          font-size: 14px;
        }

      }

      .discribe {
        font-size: 13px;
      }

      .catalog {
        width: 828px;
        padding: 0 42px 0 28px;
      }

      /deep/ .el-tabs__header {
        background-color: #fff;
        margin: 0;

        .el-tabs__item {
          padding: 0 25px !important;
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
      }

      /deep/ .el-tabs__active-bar {
        padding: 0 25px;
        margin-left: -25px;
      }
    }
  }
</style>